import { useSelector } from 'react-redux';
import { selectUserContext } from 'core/userContext';
import { PageHeader } from 'ui/pageHeader';
import { FullWidth } from 'ui/utility/fullWidth';
import { SortingContextProvider } from 'utils/contexts/sorting';
import { PaginationContextProvider } from 'utils/contexts/pagination';
import { ORG_PERMISSIONS } from 'utils/permissions';
import { OrganizationMembersQueryContextProvider } from '../../contexts/OrganizationMembersQueryContext';
import { FiltersContextProvider } from '../../contexts/FiltersContext';
import { SelectionContextProvider } from '../../contexts/SelectionContext';
import { OrganizationModalsContextProvider } from '../../contexts/OrganizationModalsContextProvider';
import { BulkActionsBar } from './BulkActionsBar';
import { PageActions } from './PageActions';
import { MembersTable } from './MembersTable';
import { Modals } from './Modals';

export const BaseMembersIndexPage = () => {
  const { rbacPermissions } = useSelector(selectUserContext);
  const hasManageMembersPermission = rbacPermissions?.includes(ORG_PERMISSIONS.ManageMembers);

  if (!hasManageMembersPermission) return null;

  return (
    <>
      <PageHeader pageActions={<PageActions />}>Organization members</PageHeader>
      <FullWidth>
        <BulkActionsBar />
        <MembersTable />
      </FullWidth>
      <Modals />
    </>
  );
};

export const MembersIndexPage = () => (
  <OrganizationMembersQueryContextProvider>
    <OrganizationModalsContextProvider>
      <FiltersContextProvider>
        <SortingContextProvider>
          <PaginationContextProvider>
            <SelectionContextProvider>
              <BaseMembersIndexPage />
            </SelectionContextProvider>
          </PaginationContextProvider>
        </SortingContextProvider>
      </FiltersContextProvider>
    </OrganizationModalsContextProvider>
  </OrganizationMembersQueryContextProvider>
);
